import { render, staticRenderFns } from "./newpage.vue?vue&type=template&id=3bd093ad&"
import script from "./newpage.vue?vue&type=script&lang=js&"
export * from "./newpage.vue?vue&type=script&lang=js&"
import style0 from "./newpage.vue?vue&type=style&index=0&id=3bd093ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports